// Allowed tag values for the external-org profile page, keyed by org type. Mirror of the
// backend external_org_profile_consts (JS can't import Python — keep the two in lockstep).
export const TAGS = {
    // Partner categories.
    partner: [
        'Ad Networks & DSPs',
        'Affiliate Networks, Offerwalls & Reward Platforms',
        'Analytics & Data Storage',
        'Preload Partner',
        'Retargeting & Re-engagement Platforms',
        'Social & Search Platforms',
        'Third-Party App Stores',
        'Third-Party Payment Platform',
        'SSPs & Mediation Platforms',
        'Campaign Optimization Automation Tools',
        'App Store Intelligence & ASO Tools',
        'Marketing Automation & Customer Engagement Platforms',
    ],
    // Agency specialties.
    agency: [
        'User Acquisition',
        'Creative & Ad Production',
        'App Store Optimization (ASO)',
        'Media Buying',
        'Performance Marketing',
        'Influencer Marketing',
        'Retention & CRM',
        'Analytics & Measurement',
        'Brand & Awareness Campaigns',
        'Full-Service Agency',
    ],
};
